import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import FPUOverviewContent from "./FPUOverviewContent";
import FPUHistoryContent from "./FPUHistoryContent";
import FPUMissionsContent from "./FPUMissionsContent";
import FPUCurrentContent from "./FPUCurrentContent";

const FPUContent = () => {
  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "🏛️",
      component: <FPUOverviewContent />,
    },
    {
      id: "history",
      label: "Sejarah & Kontribusi",
      icon: "📜",
      component: <FPUHistoryContent />,
    },
    {
      id: "missions",
      label: "Misi Internasional",
      icon: "🗺️",
      component: <FPUMissionsContent />,
    },
    {
      id: "current",
      label: "Kontingen Aktif",
      icon: "👮‍♂️",
      component: <FPUCurrentContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Formed Police Unit (FPU)"
      subtitle="Misi Pemeliharaan Perdamaian PBB"
      icon="👮"
      breadcrumbBase="Misi Internasional"
      tabs={tabs}
      footerTitle="FPU Indonesia"
      footerDescription="Berkomitmen dalam menjaga perdamaian dunia melalui kontribusi nyata dalam misi pemeliharaan perdamaian PBB dengan profesionalisme dan integritas tinggi."
      footerStats={[
        { label: "Total Peacekeepers", value: "3536+" },
        { label: "Misi Terlaksana", value: "25+" },
        { label: "Kontingen Aktif", value: "140" },
      ]}
    />
  );
};

export default FPUContent;
